import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, SimpleChanges, inject } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { IProductDataV2 } from '@df/catalog/product/product';
import { UiComponent } from '@df/ui/ui.component';
import { ProductDecorator } from '../../catalog/model/product/product.decorator';
import { NListingLabel } from './listing-label.cms-config';
import { ListingLabelService } from './listing-label.service';
import { HTMLBindingDirective } from '@df/ui/common/html-binding.directive';

@Component({
    selector: 'listing-label',
    templateUrl: './listing-label.component.html',
    styleUrl: './listing-label.component.scss',
    standalone: true,
    imports: [CommonModule, HTMLBindingDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingLabelComponent extends UiComponent {
    @Input({
        required: true
    })
    product?: ProductDecorator<IProductDataV2>;

    @Input()
    customClass?: string;

    private listingLabelService = inject(ListingLabelService);
    private attributeResource = inject(AttributeResource);

    enabled = false;
    label?: string;
    style?: NListingLabel.ILabelStyle;

    override ngOnChanges(changes: SimpleChanges) {
        if (changes['product']) {
            this.setLabels();
        }

        super.ngOnChanges(changes);
    }

    async setLabels() {
        const listingLabelValue = this.product?.getListingLabel();

        this.style = listingLabelValue ? this.listingLabelService.getLabelStyle(listingLabelValue) : undefined;

        this.label = listingLabelValue
            ? this.product?.labelShort || (this.attributeResource.getExisting('listing_label')?.getOptionLabel(listingLabelValue) as string)
            : undefined;

        this.enabled = !!this.style && !!this.label && this.listingLabelService.enabled;

        this.detectChanges();
    }
}
